"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NChangedWinPriceValidity_1 = require("../model/NChangedWinPriceValidity");

var NChangedWinPriceValidityConverter_1 = require("./NChangedWinPriceValidityConverter");
/**
 * @author Jan Prokop
 */


var NChangedWinPriceValidityConverterImpl =
/*#__PURE__*/
function (_NChangedWinPriceVali) {
  _inherits(NChangedWinPriceValidityConverterImpl, _NChangedWinPriceVali);

  function NChangedWinPriceValidityConverterImpl() {
    _classCallCheck(this, NChangedWinPriceValidityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinPriceValidityConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedWinPriceValidityConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedWinPriceValidity_1.NChangedWinPriceValidity(NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema.newPriceValidityStart.valueOfField(source), NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema.newPriceValidityEnd.valueOfField(source), NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema.oldPriceValidityStart.valueOfField(source), NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema.oldPriceValidityEnd.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        newPriceValidityStart: source.newPriceValidityStart ? conversions.fromDate(source.newPriceValidityStart) : null,
        newPriceValidityEnd: source.newPriceValidityEnd ? conversions.fromDate(source.newPriceValidityEnd) : null,
        oldPriceValidityStart: source.oldPriceValidityStart ? conversions.fromDate(source.oldPriceValidityStart) : null,
        oldPriceValidityEnd: source.oldPriceValidityEnd ? conversions.fromDate(source.oldPriceValidityEnd) : null
      });
      return result;
    }
  }]);

  return NChangedWinPriceValidityConverterImpl;
}(NChangedWinPriceValidityConverter_1.NChangedWinPriceValidityConverter);

exports.NChangedWinPriceValidityConverterImpl = NChangedWinPriceValidityConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedWinPriceValidityConverterImpl.QUALIFIER = {
  documentType: NChangedWinPriceValidity_1.NChangedWinPriceValidity.name
};